import Page from 'v5/client/propertySearch/PropertiesPageRelayFeatureGate.bs'
import { withMainLayout } from '../../pagesComponents/MainApp'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'

const PropertiesPage = requireAuthenticatedAgent(Page)

PropertiesPage.getLayout = withMainLayout

export default PropertiesPage
